<template>
  <div class="interview-video">
    <div class="video-mask">
      <div class="video-close" @click="closeVideo">
        <img src="../../assets/imgs/admin-order/close.png">
      </div>
    </div>
    <div class="video-container">
      <div class="share-box" @click="showShare">
        <div class="wx-share"><img src="../../assets/imgs/wechat.png"></div>
        <span class="desc">分享给顾客</span>
      </div>
      <video src="https://o.666visa.cn/video/ssq_interview.mp4" ref="video" controls autoplay="autoplay" loop></video>
    </div>
  </div>
</template>

<script>
export default {
  name: 'interviewVideo',
  methods: {
    closeVideo() {
      this.$emit('close');
    },
    showShare() {
      this.$refs.video.pause();
      this.$emit('share');
    },
  },
};
</script>

<style scoped lang="less">
.interview-video {
  .video-mask {
    background-color: #000;
    opacity: 0.9;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1100;
    cursor: pointer;
    .video-close {
      width: 34px;
      height: 34px;
      background-color: rgba(255, 255, 255, 0.1);
      background-size: 34px 34px;
      position: absolute;
      border-radius: 100%;
      top: 20px;
      right: 20px;
      z-index: 1200;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .video-container {
    position: fixed;
    z-index: 1101;
    top: 50%;
    left: 50%;
    height: 600px;
    width: 900px;
    transform: translate(-50%, -50%);
    padding-top: 94px;
    .share-box {
      position: absolute;
      top: 44px;
      left: 0;
      display: flex;
      align-items: center;
      cursor: pointer;
      .wx-share {
        width: 36px;
        height: 36px;
        background-color: rgba(255, 255, 255, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
      }
      .desc {
        color: #fff;
        font-size: 12px;
        margin-left: 10px;
      }
    }
    video {
      width: 960px;
      height: 540px;
    }
    video::-internal-media-controls-download-button {
      display: none;
    }

    video::-webkit-media-controls-enclosure {
      overflow: hidden;
    }

    video::-webkit-media-controls-panel {
      width: calc(100% + 3px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/interview-video.vue